import I18n from '@utils/i18n.utils';
import {SelectItem} from '@components/inputs/select/Select.component';

export enum FacturationRuleType {
  SERVICE_KIND_DISTINCT = 'SERVICE_KIND_DISTINCT',
  CLIENT_UNIT_TOGETHER = 'CLIENT_UNIT_TOGETHER',
  CLIENT_UNIT_DISTINCT = 'CLIENT_UNIT_DISTINCT',
  OTHER_CLIENT_UNIT = 'OTHER_CLIENT_UNIT',
  SERVICE_SCHEDULED_OR_NOT = 'SERVICE_SCHEDULED_OR_NOT',
  WASTE_FAMILY_DISTINCT = 'WASTE_FAMILY_DISTINCT',
  INVOICE_ADDRESS = 'INVOICE_ADDRESS',
}

export namespace FacturationRuleType {
  export const selectItems = (fromOrganisationUnit?: boolean): SelectItem[] => {
    if (fromOrganisationUnit) {
      return [
        FacturationRuleType.SERVICE_KIND_DISTINCT,
        FacturationRuleType.SERVICE_SCHEDULED_OR_NOT,
        FacturationRuleType.WASTE_FAMILY_DISTINCT,
      ].map((it) => ({label: I18n.t(`global.facturationRuleType.${it}`), value: it}) );
    } else {
      return [
        FacturationRuleType.SERVICE_KIND_DISTINCT,
        FacturationRuleType.CLIENT_UNIT_TOGETHER,
        FacturationRuleType.CLIENT_UNIT_DISTINCT,
        FacturationRuleType.OTHER_CLIENT_UNIT,
        FacturationRuleType.SERVICE_SCHEDULED_OR_NOT,
        FacturationRuleType.WASTE_FAMILY_DISTINCT,
        FacturationRuleType.INVOICE_ADDRESS,
      ]
        .map((it) => ({label: I18n.t(`global.facturationRuleType.${it}`), value: it}) );
    }
  };
}
